<!--
 * @Description:
 * @Autor: Sia
 * @Date: 2019-11-06 11:40:31
 * @LastEditors  : Sia
 * @LastEditTime : 2020-01-16 11:21:31
 -->
<!-- 报表 ==== 对比 -->
<template>
<!-- 市场 - 概况 -->
  <div class="">
    <div class="flex-1">
      <span class="text-bold">{{title}}</span>
      <span>{{time_title}}</span>
    </div>
    <div class="block-preview">
      <div class="flex-wrap  details_content">
        <div class="flex-align-center width-full flex-main-start"
             style="line-height: 28px">
          <div v-if="headerShow[0]"
               :style="monthClass">
            <component :is="header.time"
                       @change="formatTime">
            </component>
            <component :is="header.quckTime"
                       @change="time_change"
                       :tabPosition='tabPosition'>
            </component>
            <div class="blank_div_cell"></div>
            <component :is="header.datePicker"
                       :class="compareClass[0]"
                       :time="query.time"
                       @change="changeStart">
            </component>
          </div>
          <div class="flex-main-start"
               v-if="headerShow[15]">
            <span class="padding-right-s font-deep-gray-xxs">时间：</span>
            <el-quarter-range isNoStartOne style="margin-left:10px" :value.sync="quarterValueCustom">
                        </el-quarter-range>
          </div>
          <div class="flex-main-start"
               v-if="headerShow[16]">
            <span class="padding-right-s font-deep-gray-xxs">时间：</span>

            <el-date-picker
              style="margin-left: 10px;width: 80px"
              v-model="yearValue"
              type="year"
              :clearable="false"
              :editable="false"
              format="yyyy年"
              placeholder="选择年">
              </el-date-picker>
          </div>
          <div class="flex-main-start"
               :class="padd_after"
               v-if="headerShow[1]">
            <span class="padding-right-s font-deep-gray-xxs">门店：</span>
            <!-- <el-cascader :class="compareClass[1]"
                         popper-class="select_drop_theme"
                         class="select_theme"
                         :props="{ expandTrigger: 'hover' }"
                         :options="storeList"
                         v-model="initStore"
                         @change="changeStore">
            </el-cascader> -->
             <TotastFour
              :project="allLiliaos"
              initEmp="全部"
              @changeStore="changeStore"
            ></TotastFour>
          </div>
          <div class="flex-main-start padding-left-40"
               v-if="headerShow[2]">
            <span class="padding-right-s font-deep-gray-xxs">顾客：</span>
            <el-select :class="compareClass[2]"
                       v-model="queryData.isOld"
                       @change="changeCustomer">
              <el-option v-for="item in customerList"
                         :key="item.isOld"
                         :label="item.label"
                         :value="item.isOld">
              </el-option>
            </el-select>
          </div>
          <div class="flex-main-start padding-left-40"
               v-show="headerShow[3]">
            <span class="padding-right-s font-deep-gray-xxs">会员：</span>
            <el-select :class="compareClass[3]"
                       v-model="queryData.customerType"
                       @change="changeMember">
              <el-option v-for="item in memberList"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="flex-main-start padding-left-40"
               v-if="headerShow[7]">
            <span class="padding-right-s font-deep-gray-xxs">储值卡：</span>
            <el-select :class="compareClass[7]"
                       v-model="cardType"
                       @change="changeCard">
              <el-option v-for="item in cardList"
                         :key="item.cardType"
                         :label="item.label"
                         :value="item.cardType">
              </el-option>
            </el-select>
          </div>
          <div class="flex-main-start padding-left-40"
               v-if="headerShow[9]">
            <span class="padding-right-s font-deep-gray-xxs">活动：</span>
            <div class="button"
                 :class="compareClass[9]">
              <ActivityTotast :dialog="activityShow"
                              :activityList="activityList"
                              :initAct='initAct'
                              :actInitName='actInitName'
                              :initId='initId'
                              @change="changeAcitivity"></ActivityTotast>
            </div>
          </div>
          <div class="flex-main-start padding-left-40"
               v-if="headerShow[10]">
            <span class="padding-right-s font-deep-gray-xxs">优惠券：</span>
            <div class="button"
                 :class="compareClass[10]">
              <CouponsTotast :dialog="couponsShow"
                             :couponsList="couponsList"
                             :initCop='initCop'
                             :couInitName='couInitName'
                             :initId='initId'
                             @change="changeCoupons"></CouponsTotast>
            </div>
          </div>
          <div class="flex-main-start padding-left-40"
               v-if="headerShow[11]">
            <span class="padding-right-s font-deep-gray-xxs">来源渠道：</span>
            <el-select :class="compareClass[11]"
                       v-model="queryData.custSource"
                       @change="changeCome">
              <el-option v-for="item in comeChannel"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value"></el-option>
            </el-select>
          </div>
          <div class="flex-main-start padding-left-40"
               v-if="headerShow[12]">
            <span class="padding-right-s font-deep-gray-xxs">券类型：</span>
            <el-select :class="compareClass[12]"
                       v-model="queryData.discountCategory"
                       @change="changeCouponType">
              <el-option v-for="item in couponList"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="flex-main-start padding-left-40"
               v-if="headerShow[13]">
            <span class="padding-right-s font-deep-gray-xxs">活动类型：</span>
            <el-select :class="compareClass[13]"
                       v-model="queryData.discountCategory"
                       @change="changeActivityType">
              <el-option v-for="item in activityTypeList"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="flex-main-start padding-left-40"
               v-if="headerShow[14]">
            <span class="padding-right-s font-deep-gray-xxs">商品状态：</span>
            <el-select :class="compareClass[14]"
                       v-model="queryData.dimensionStatus"
                       @change="changDimensionStatus">
              <el-option v-for="item in goodsStatusList"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </div>
          <!-- <div class="flex-main-start padding-left-40"
               v-if="headerShow[17]">
               <vipHeaderDialog :propDateRange="[queryData.startTime,queryData.endTime]" :headerMemberInfoQueryParam.sync="headerMemberInfoQueryParam" />
          </div> -->

          <div class="right right_switch flex-nowrap"
               v-if="contrastStatus">
            <span class="font-deep-gray-xxs padding-right-s">对比：</span>
            <span class="padding-right-md">
              <el-switch v-model="switchStatus"
                         style="width: 120px"
                         active-color="#3C76FF"
                         inactive-color="#EDEDED"
                         @change="onContrast">
              </el-switch>
            </span>
            <transition name="slide-fade">
              <div v-if="switchStatus"
                   class="flex-nowrap">
                <el-select v-model="checkId"
                           placeholder="请选择"
                           @change="updateCheck">
                  <el-option v-for="(item, index) in options"
                             :key="index"
                             :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>
                <span v-if="checked[0]"
                      class="padding-left-10">
                  <label>
                    <div v-if="!showPick"
                         class="a_pick font-theme"
                         :style="{'width':(header.datePicker==='MonthPicker'?'136px':'174px')}">与其它时间段对比</div>
                    <component month-id="test7"
                               :is="header.datePicker"
                               :time="query.time_contrast"
                               @change="changeEnd"></component>
                  </label>
                </span>
                <span class="padding-left-10-new"
                      v-if="checked[1]">
                  <div class="el-select">
                    <TotastFour
                      :project="allLiliaos"
                      initEmp="全部"
                      class="store_class"
                      @changeStore="changeStore_other"
                    ></TotastFour>
                  </div>
                </span>
                <span v-if="checked[2]"
                      class="padding-left-10">
                  <div class="el-select">
                    <el-select class="font-theme"
                               placeholder="选择对比顾客"
                               v-model="queryData.compareIsOld"
                               @change="changeCustomer_other">
                      <el-option v-for="item in customerList"
                                 :key="item.isOld"
                                 :label="item.label"
                                 :value="item.isOld">
                      </el-option>
                    </el-select>
                  </div>
                </span>
                <span class="padding-left-10"
                      v-if="checked[3]">
                  <div class="el-select">
                    <el-select class="font-theme"
                               placeholder="选择对比会员"
                               v-model="queryData.compareCustType"
                               @change="changeMember_other">
                      <el-option v-for="item in memberList"
                                 :key="item.value"
                                 :label="item.label"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </span>
                <span class="padding-left-10"
                      v-if="checked[7]">
                  <div class="el-select">
                    <el-select class="font-theme"
                               placeholder="选择对比储值卡类型"
                               v-model="queryData.compareCardType"
                               @change="changeCard_other">
                      <el-option v-for="item in cardList"
                                 :key="item.cardType"
                                 :label="item.label"
                                 :value="item.cardType">
                      </el-option>
                    </el-select>
                  </div>
                </span>
                <div class="p-l-10"
                     v-if="checked[8]">
                  <div>
                    <div class="button font-theme">
                      <totastTwo :project="levelProject"
                                 @change="changePerContrant"
                                 :compare='true'></totastTwo>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as util from "../../../common/util";
import * as queryUtil from "../../../common/query";
import * as consts from "../../../common/const";
import * as config from "../../../common/config";
import moment from "moment";
import { header } from "./component";
import elQuarterRange from './el-quarter-range/index.vue'

export default {
  components: {
    ...header,
    elQuarterRange
  },
  props: {
    title: [String],
    constantKey: [String],
    empInitName: [String],
    couInitName: [String],
    actInitName: [String],
    createDate: [String],
    constantKeyOne: [String],
    constantKeyTwo: [String],
    identifyKey: [String],
    contrastStatus: {
      type: Boolean,
      default: function() {
        return true;
      }
    },
    headerChange: [Boolean],
    header: [Object],
    sortIndex: [Number],
    page: [Object],
    type: [Number],
    initId: [Number],
    dateFormat: [Number],
    headerType: [Number],
    parentID: [Number],
    headerShow: [Array],
    padd_after: {
      type: String,
      default: function() {
        return "padding-left-40";
      }
    }
  },
  data() {
    const startMonth = moment().startOf('quarter').month() + 1
    const quarterStartMonth = moment().format('YYYY') + '-' + (startMonth > 10 ? startMonth : '0' + startMonth)
    const end = moment().endOf('quarter').format('YYYY-MM')
    return {
      switchStatus: false,
      query: {
        time: [],
        time_contrast: [],
        time_contrastEnd: []
      },
      store: JSON.parse(localStorage.getItem("store")) || [],
      queryData: {
        startTime: "",
        endTime: "",
        storeID: JSON.parse(localStorage.getItem("store"))[0].children[0].value,
        customerType: consts.MemberClass[0].value,
        isOld: consts.CustomerClass[0].isOld,
        custSource: JSON.parse(localStorage.getItem("sourceFlow"))[0].value,
        miniPrice: 0,
        maxPrice: 0,
        empID: null,
        compareType: 0,
        paramName: "全部",
        compareParam: "",
        comParamName: "",
        identifyKey: 0,
        headerType: 0,
        constantKey: "",
        parentID: 0,
        constantType: 0,
        type: 0,
        categoryID: "",
        prodID: 0,
        dateFormat: 1,
        pageNum: 1,
        sortIndex: 1,
        ascending: 0,
        sqlType: 1,
        pageSize: 20,
        // status: 1,
        identityType: 1,
        discountCategory: -1,
        dimensionStatus: 1,
      },
      customerList: consts.CustomerClass,
      memberList: consts.MemberClass,
      cardList: consts.CardType,
      cardType: consts.CardType[0].cardType,
      comeChannel: JSON.parse(localStorage.getItem("sourceFlow")) || [],
      couponList: consts.couponList,
      activityTypeList: consts.activityTypeList,
      goodsStatusList: consts.goodsStatusList,
      initStore: ["上海", 0],
      tabPosition: "最近30天",
      time_title: "",
      checkId: 1,
      checked: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false
      ],
      showPick: false,
      monthClass: "display:flex",
      empName: "",
      couponsShow: true,
      activityShow: true,
      couponsList: [],
      activityList: [],
      startTime: "",
      endTime: "",
      initAct: "请选择活动",
      initCop: "请选择优惠券",
      initCompareAct: "选择对比活动",
      initCompareCop: "选择对比优惠券",
      activityName: "",
      couponName: "",
      timeQuick: "",
      quarterValueCustom: [quarterStartMonth, end],
      yearValue: moment().format('YYYY'),
      headerMemberInfoQueryParam: null, //会员资源搜索params

    };
  },
  created() {
    // console.log(this.$route.name, this.initId);
    if (this.header.time === "Month"){
      this.monthClass = "";
    }
    // 特殊情况。理疗师详情页面，由概况的列表点击跳转进来，有初始默认值，否则弹框提示
    if (this.$route.name === "perform_analyze") {
      if (this.initId === 0 || this.initId === undefined) {
        this.dialogShow = true;
      } else {
        this.queryData.empID = this.initId;
        queryUtil.setQuery(this.queryData);
        this.dialogShow = false;
      }
    } else if (
      this.$route.name !== "coupons_index" &&
      this.$route.name.includes("coupons_")
    ) {
      // 特殊情况。优惠券详情页面，由概况的列表点击跳转进来，有初始默认值，否则弹框提示
      if (this.initId === 0 || this.initId === undefined) {
        this.couponsShow = true;
      } else {
        this.couponsShow = false;
        this.queryData.discountID = this.initId;
        this.queryData.paramName = this.couInitName;
        this.initCop = this.couInitName;
        this.startTime = this.createDate;
        this.endTime = util.nowTime();
        // if (this.initCop.length > 10) {
        //   this.initCop = this.initCop.slice(0, 10) + "...";
        // }
        queryUtil.setQuery(this.queryData);
      }
    } else if (
      this.$route.name !== "activity_index" &&
      this.$route.name.includes("activity_")
    ) {
      // 特殊情况。活动详情页面，由概况的列表点击跳转进来，有初始默认值，否则弹框提示
      if (this.initId === 0 || this.initId === undefined) {
        this.activityShow = true;
      } else {
        this.activityShow = false;
        this.queryData.discountID = this.initId;
        this.queryData.paramName = this.actInitName;
        this.initAct = this.actInitName;
        this.startTime = this.createDate;
        this.endTime = util.nowTime();
        // if (this.initAct.length > 10) {
        //   this.initAct = this.initAct.slice(0, 10) + "...";
        // }
        queryUtil.setQuery(this.queryData);
      }
    }

    var {
      headerType,
      constantKey,
      parentID,
      type,
      dateFormat,
      sqlType,
      sortIndex,
      identityType,
      discountType
    } = this.page;
    this.queryData = Object.assign(
      {},
      this.queryData,
      {
        headerType,
        constantKey,
        parentID,
        type,
        dateFormat,
        sqlType,
        sortIndex,
        identityType,
        discountType
      },
      { identifyKey: this.identifyKey || this.page.tableKey }
    );
    if (this.header.quckTime === "MonthTab") {
      this.tabPosition = "最近3个月";
      this.tab_time = this.query.time = util.report.getMonth(this.tabPosition);
      let time = util.report.queryMoreMonth(this.tab_time);
      this.time_change([time.startTime, time.endTime]);
    } else if (this.header.quckTime === "MonthTabSix") {
      this.tabPosition = "最近6个月";
      this.tab_time = this.query.time = util.report.getMonth(this.tabPosition);
      let time = util.report.queryMoreMonth(this.tab_time);
      this.time_change([time.startTime, time.endTime]);
    } else {
      if (this.header.quckTime !== "") {
        if (this.header.quckTime === "TimeTab") {
          this.tabPosition = "上周";
        } else if (
          this.header.quckTime === "MonthTabTwo" ||
          this.header.quckTime === "MonthTabThree"
        ) {
          this.tabPosition = "最近7天";
        } else if (this.header.quckTime === "MonthTabSix") {
          this.tabPosition = "最近6个月";
        }
        this.tab_time = this.query.time = util.report.getime(this.tabPosition);
        let time = util.report.getime(this.tabPosition);
        this.queryData = Object.assign(
          {},
          this.queryData,
          util.report.queryTime(time)
        );
      } else {
        this.tabPosition = "";
      }
      queryUtil.setQuery(this.queryData);
    }
    if (this.header.time === "Month") {
      let val = this.moment().format("YYYY-MM");
      this.time_title = "（" + val + ")";
      this.queryData = Object.assign(
        {},
        this.queryData,
        util.report.queryMonth(val)
      );
      if(this.$route.name.indexOf('monthly_target_manage') !== -1){
        this.queryData.timelyType = 1
        this.queryData.month = moment().format('YYYY-MM')
        this.queryData.startTime = moment().format('YYYY-MM')
        this.queryData.endTime = moment().format('YYYY-MM')
        this.queryData.constantType = 8
        this.queryData.areaType = 1
        this.time_title = `（${this.queryData.startTime}）`
      }else if(this.$route.name.indexOf('yearly_target_manage') !== -1){
        this.queryData.timelyType = 3
        this.queryData.month = moment().format('YYYY-MM')
        this.queryData.startTime = moment().format('YYYY-01')
        this.queryData.endTime = moment().format('YYYY-12')
        this.queryData.constantType = 17
        this.queryData.areaType = 4
        this.time_title = `（${moment(this.queryData.startTime).format('YYYY')}）`
      }else if(this.$route.name.indexOf('quarterly_target_manage') !== -1){
        this.queryData.timelyType = 2
        this.queryData.month = moment().format('YYYY-MM')
        this.queryData.startTime = this.quarterValueCustom[0]
        this.queryData.endTime = this.quarterValueCustom[1]
        this.time_title = `（${this.queryData.startTime}~${this.queryData.endTime}）`
        this.queryData.constantType = 18
        this.queryData.areaType = 3
      }
      queryUtil.setQuery(this.queryData);
    } else if (this.header.time === "MonthTwo") {
      let val = this.moment().format("YYYY-MM");
      this.time_title = "（" + val + ")";
      this.queryData.startTime = val;
      queryUtil.setQuery(this.queryData);
    }
    // 市场报表，会员分析，积分分析模块，顾客类型没有散客
    if (
      this.header.name.includes("cust_") ||
      this.header.name.includes("integral_")
    ) {
      // 优惠券分析增加潜客
      this.customerList = consts.CustomerClassTwo;
    } else if (this.header.name.includes("coupons_")) {
      this.customerList = consts.CustomerClassThree;
    }
  },
  computed: {
      allLiliaos() {
      let b = [];
      b.push(JSON.parse(localStorage.getItem("regionaList")));
      return b;
    },
    options() {
      let a = [];
      this.headerShow.forEach((item, i) => {
        if (item && this.header.options[i]) {
          a.push(this.header.options[i]);
        }
      });
      if (this.header.name === "perform_contrast") {
        a.pop();
      }
      return a;
    },
    tab_time: {
      get() {
        return util.report.getime(this.tabPosition);
      },
      set(val) {
        const self = this;
        self.time_title =
          val[0].length <= 10
            ? `（${val.join(" ~ ")}）`
            : `（${val.join(" 与 ")}）`;
      }
    },
    compareClass() {
      let theme = [];
      theme = this.checked.map(check => {
        return this.contrastStatus && check ? "font-theme" : "";
      });
      return theme;
    },
    storeList() {
      return this.store;
    },
    levelProject() {
      let str = JSON.parse(localStorage.getItem("store"));
      if (str.length) {
        str.forEach(item => {
          if (queryUtil.filterType(item.children)) {
            item.children.splice(0, 1);
          }
        });
      }
      return str;
    },
    allLiliao() {
      let str = JSON.parse(localStorage.getItem("store"));
      str[0].children.splice(0, 1);
      str[0].children.forEach(item => {
        item.id = item.value;
      });
      // str[0].children.unshift({id:0,label:'全部',value:0})
      let a = [
        {
          id: 1,
          label: "上海",
          children: [
            { id: 0, label: "全部", value: 0, children: str[0].children }
          ]
        }
      ];
      // console.log(a);
      return a;
    }
  },
  watch: {
    yearValue(v) {
        this.queryData.month = moment(v).format('YYYY')
        // console.log(v);
        this.time_title = '（' + this.queryData.month + ')'
        queryUtil.setQuery(this.queryData)
    },
    quarterValueCustom(v){
        if(!v){
            this.queryData.startTime = ''
            this.queryData.endTime = ''
        }else{
            this.queryData.startTime = moment(v[0]).format('YYYY-MM')
            this.queryData.endTime = moment(v[1]).format('YYYY-MM')
            this.queryData.month = moment(v[0]).format('YYYY')
            this.time_title = `（${this.queryData.startTime}~${this.queryData.endTime}）`
        }
        queryUtil.setQuery(this.queryData)
    },
    contrastStatus(val) {
      const self = this;
      if (val && self.checked[0]) {
        let b = self.queryData.compareParam.split("/");
        self.tab_time = [
          `${self.queryData.startTime}~${self.queryData.endTime} 与
                         ${b[0]}~${b[1]} `
        ];
      } else {
        self.tab_time = [self.queryData.startTime, self.queryData.endTime];
        this.queryData.compareType = 0;
        this.queryData.comParamName = "";
        this.queryData.compareParam = "";
        queryUtil.setQuery(this.queryData);
      }
    },
    // 切换卡片，表头的某一项不显示，则归为原始值
    headerShow(v) {
      // console.log(this.headerChange,v);
      this.changeContrast();
      if (this.headerChange) {
        v.forEach((item, i) => {
          if (!item) {
            switch (i) {
              case 2:
                this.queryData.isOld = consts.CustomerClass[0].isOld;
                // this.queryData.isOldName=consts.CustomerClass[0].label
                break;
              case 3:
                this.queryData.customerType = consts.MemberClass[0].value;
                // this.queryData.custTypeName=consts.MemberClass[0].label
                break;
              case 4:
                this.initPass = [-1];
                this.queryData.bookSource = consts.passFlow[0].value;
                break;
              case 5:
                // 4和5会冲突，所以当4显示时，5不做任何处理
                if (!v[4]) {
                  this.queryData.bookSource = consts.passFlow[0].value;
                }
                break;
              case 6:
                this.queryData.prodID = 0;
                this.queryData.categoryID = "";
                this.initProject = [0];
                break;
              case 7:
                this.queryData.maxPrice = 0;
                this.queryData.miniPrice = 0;
                this.cardType = -1;
                break;
              case 17:
                this.queryData.memberInfoQueryParam = null
                break
              default:
                break;
            }
          }
        });
        queryUtil.setQuery(this.queryData);
      }
    },
    constantKey(v) {
      this.queryData.constantKey = v;
      queryUtil.setQuery(this.queryData);
    },
    constantKeyOne(v) {
      this.queryData.constantKey1 = v;
      queryUtil.setQuery(this.queryData);
    },
    constantKeyTwo(v) {
      this.queryData.constantKey2 = v;
      queryUtil.setQuery(this.queryData);
    },
    identifyKey(v) {
      this.queryData.identifyKey = v;
      queryUtil.setQuery(this.queryData);
    },
    type(v) {
      this.queryData.type = v;
      queryUtil.setQuery(this.queryData);
    },
    headerType(v) {
      this.queryData.headerType = v;
      queryUtil.setQuery(this.queryData);
    },
    "page.sqlType": {
      deep: true, // 深度监听设置为 true
      handler: function(newV) {
        this.queryData.sqlType = newV;
        queryUtil.setQuery(this.queryData);
      }
    },
    parentID(v) {
      this.queryData.parentID = v;
      queryUtil.setQuery(this.queryData);
    },
    dateFormat(v) {
      this.queryData.dateFormat = v;
      queryUtil.setQuery(this.queryData);
    },
    sortIndex(v) {
      this.queryData.sortIndex = v;
      queryUtil.setQuery(this.queryData);
    },
  },
  methods: {
    setQueryData(queryData){
      this.queryData = {
        ...queryData
      }
      queryUtil.setQuery(this.queryData)
    },
    updateQuery() {
      const self = this;
      queryUtil.setQuery(self.queryData);
      queryUtil.setQueryTable(consts.clearTableQuery);
    },
    clearQuery(v) {
      const self = this;
      self.query = Object.assign({}, self.query, {
        time_contrast: v
      });
    },
    // 时间：月或年
    formatTime(val) {
      let a = this.moment(val).format("YYYY-MM");
      this.time_title = "（" + a + ")";
      this.queryData = Object.assign(
        {},
        this.queryData,
        util.report.queryMonth(val),
        {
          month: moment(val).format("YYYY-MM")
        }
      );
      queryUtil.setQuery(this.queryData);
    },
    // 快捷切换3,6,9月
    time_change(val) {
      if (val === undefined) return false;
      this.timeQuick = val[0];
      if (this.timeQuick === "活动至今") {
        val = [this.startTime, this.endTime];
      }
      this.tab_time = this.query.time = val;
      this.$emit("select_header", this.query);
      this.changeStart(val);
    },
    // 改变时间
    changeStart(val) {
      const self = this;
      let start = [];
      if (this.header.datePicker === "DatePicker") {
        // 时间选择器为年月日
        start = val.map(item => self.moment(item).format("YYYY-MM-DD"));
      } else if (this.header.datePicker === "MonthPicker") {
        // 时间选择器为年月
        if (val[0].split("-").length <= 2) {
          start.push(
            self
              .moment(val[0])
              .startOf("month")
              .format("YYYY-MM-DD")
          );
          if (self.moment().format("YYYY-MM") === val[1]) {
            start.push(
              self
                .moment()
                .subtract(1, "days")
                .format("YYYY-MM-DD")
            );
          } else {
            start.push(
              self
                .moment(val[1])
                .endOf("month")
                .format("YYYY-MM-DD")
            );
          }
        } else {
          start = val;
        }
      }
      self.query.time = start;
      self.tabPosition = util.report.timeTab(start);
      self.query.time_contrast = util.report.sameTime(start);
      // 数据层
      let time = util.report.queryCompareTime(self.query.time_contrast);
      if (self.queryData.compareType === 1) {
        self.queryData = Object.assign(
          {},
          self.queryData,
          util.report.queryTime(start),
          time
        );
        self.tab_time = [
          self.query.time.join("~"),
          self.query.time_contrast.join("~")
        ];
        self.queryData.compareParam = self.query.time_contrast.join("/");
      } else {
        self.queryData = Object.assign(
          {},
          self.queryData,
          util.report.queryTime(start)
        );
        self.tab_time = start;
      }
      self.$emit("select_header", self.query);
      self.updateQuery();
    },
    // 改变门店
    // changeStore(val) {
    //   this.store[0].children.forEach(item => {
    //     if (item.value === val[1]) {
    //       if (this.queryData.compareType && this.queryData.compareType === 2) {
    //         this.queryData.paramName = item.label;
    //       }
    //       this.queryData.storeID = val[1];
    //     }
    //   });
    //   queryUtil.setQuery(this.queryData);
    // },
     changeStore(val) {
      this.queryData.storeIDs = val.empIDs;
      queryUtil.setQuery(this.queryData);
    },
    // 改变顾客类型
    changeCustomer(val) {
      this.customerList.forEach(item => {
        if (item.isOld === val) {
          if (this.queryData.compareType === 6) {
            this.queryData.paramName = item.label;
          }
          this.queryData.isOld = val;
        }
      });
      queryUtil.setQuery(this.queryData);
    },
    // 改变会员类型
    changeMember(val) {
      this.memberList.forEach(item => {
        if (item.value === val) {
          if (this.queryData.compareType === 3) {
            this.queryData.paramName = item.label;
          }
          this.queryData.customerType = val;
        }
      });
      queryUtil.setQuery(this.queryData);
    },
    // 改变储值卡类型
    changeCard(val) {
      this.cardList.forEach(item => {
        if (item.cardType === val) {
          switch (item.label) {
            case "全部":
              this.queryData.miniPrice = 0;
              this.queryData.maxPrice = 0;
              // this.queryData.paramName=item.label
              break;
            case "10000及以上":
              this.queryData.miniPrice = 10000;
              this.queryData.maxPrice = 0;
              // this.queryData.paramName=item.label
              break;
            default:
              let a = item.label.split("-");
              this.queryData.miniPrice = parseInt(a[0]);
              this.queryData.maxPrice = parseInt(a[1]);
              // this.queryData.paramName=item.label
              break;
          }
          if (this.queryData.compareType && this.queryData.compareType === 8) {
            this.queryData.paramName = item.label;
          }
        }
      });
      this.updateQuery();
    },
    // 改变理疗师
    changePer(val) {
      if (!Object.keys(val).length) {
        // delete this.queryData.empIDs
        this.queryData.empIDs = null;
        this.queryData = Object.assign({}, this.queryData);
      } else {
        this.queryData = Object.assign({}, this.queryData, val);
      }
      // 记录被对比的理疗师名字，传给后端
      this.empName = val.paramName;
      this.updateQuery();
    },
    // 改变活动
    changeAcitivity(val) {
      this.queryData.discountID = val[0].chooseID;
      this.queryData.paramName = val[0].chooseName;
      this.initAct = val[0].chooseName;
      val[0].startTime === null
        ? (this.startTime = "2015-01-01")
        : (this.startTime = val[0].startTime);
      this.endTime = util.nowTime();
      this.activityName = val[0].chooseName;
      // if (this.initAct.length > 10) {
      //   this.initAct = this.initAct.slice(0, 10) + "...";
      // }
      if (this.timeQuick === "活动至今") {
        this.time_change(["活动至今"]);
      } else {
        this.time_change();
      }
      queryUtil.setQuery(this.queryData);
    },
    // 改变优惠券名称
    changeCoupons(val) {
      this.queryData.discountID = val[0].chooseID;
      this.queryData.paramName = val[0].chooseName;
      this.initCop = val[0].chooseName;
      val[0].startTime === null
        ? (this.startTime = "2015-01-01")
        : (this.startTime = val[0].startTime);
      this.endTime = util.nowTime();
      this.couponName = val[0].chooseName;
      // if (this.initCop.length > 10) {
      //   this.initCop = this.initCop.slice(0, 10) + "...";
      // }
      if (this.timeQuick === "活动至今") {
        this.time_change(["活动至今"]);
      } else {
        this.time_change();
      }
      queryUtil.setQuery(this.queryData);
    },
    // 改变来源渠道
    changeCome(val) {
      this.queryData.custSource = val;
      queryUtil.setQuery(this.queryData);
    },
    // 改变优惠券类型
    changeCouponType(val) {
      this.queryData.discountCategory = val;
      queryUtil.setQuery(this.queryData);
    },
    // 改变活动类型
    changeActivityType(val) {
      this.queryData.discountCategory = val;
      queryUtil.setQuery(this.queryData);
    },
    // 改变商品状态
    changDimensionStatus(val) {
      this.queryData.dimensionStatus = val;
      queryUtil.setQuery(this.queryData);
    },
    // 开启对比 默认对比
    onContrast(val) {
      const self = this;
      if (!this.headerShow[0]) {
        self.checkId = val ? 2 : 0;
      } else {
        self.checkId = val ? 1 : 0;
      }
      self.showPick = !val;
      self.checked = self.checked.map(() => false);
      if (!this.headerShow[0]) {
        val ? (self.checked[1] = true) : (self.checked[1] = false);
      } else {
        val ? (self.checked[0] = true) : (self.checked[0] = false);
      }
      // 对比时间默认
      if (val) {
        self.queryData = Object.assign({}, self.queryData, consts.clearCompare);
        self.clearQuery(util.report.sameTime(self.query.time));
        console.log(this.queryData.paramName);
      } else {
        // 不对比
        if (self.queryData.compareType !== 0) {
          self.queryData = Object.assign(
            {},
            self.queryData,
            consts.clearCompare,
            {
              compareType: 0,
              comParamName: "",
              compareParam: "",
              compareStoreIDs: []
            }
          );
          self.tab_time = self.query.time;
          self.updateQuery();
          // 反选
          self.clearQuery([]);
        }
        self.$emit("select_header", self.query);
      }
    },
    // 切换对比项目
    updateCheck(index) {
      this.$store.commit({
        type: "getPieIndex",
        index: ""
      });
      const self = this;
      self.checkId = index;
      self.checked = self.checked.map(() => false);
      self.checked.splice(index - 1, 1, true);
      self.showPick = false;
      self.queryData = Object.assign({}, self.queryData, consts.clearCompare, {
        compareType: 0,
        comParamName: "",
        paramName: ""
      });
    },
    // 切换小卡片，条件变化，对比状态关闭
    changeContrast(i) {
      if (this.headerChange) {
        this.switchStatus = false;
        this.queryData = Object.assign(
          {},
          this.queryData,
          consts.clearCompare,
          { compareType: 0, comParamName: "", paramName: "", compareParam: "" }
        );
        this.compareClass.forEach((item, i) => {
          this.compareClass[i] = "";
        });
        queryUtil.setQuery(this.queryData);
      }
    },
    // 对比时间
    changeEnd(val) {
      this.showPick = true;
      this.query.time_contrast = util.report.sameStart(this.query.time, val);
      this.tab_time = [
        this.query.time.join("~"),
        this.query.time_contrast.join("~")
      ];
      this.$emit("select_header", this.query);
      // 数据
      this.queryData = Object.assign({}, this.queryData, {
        compareType: 1,
        compareParam:
          this.query.time_contrast[0] + "/" + this.query.time_contrast[1],
        paramName: ""
      });
      this.updateQuery();
    },
    // 对比门店
    changeStore_other(val) {
      this.queryData.comParamName = val.empNames.length > 1 ? '全部' : val.empNames.join(',')
      this.queryData.compareStoreIDs = val.empIDs;
      this.queryData.compareType = 2
      this.updateQuery();
    },
    // 对比会员
    changeMember_other(val) {
      this.memberList.forEach(item => {
        if (item.value === val)
          this.queryData = Object.assign({}, this.queryData, {
            comParamName: item.label,
            compareParam: val.toString(),
            compareType: 3
          });
        // 对比的时候，让paramName等于正常下拉框此时的label
        if (item.value === this.queryData.customerType)
          this.queryData.paramName = item.label;
      });
      this.updateQuery();
    },
    // 对比顾客
    changeCustomer_other(val) {
      this.customerList.forEach(item => {
        if (item.isOld === val)
          this.queryData = Object.assign({}, this.queryData, {
            comParamName: item.label,
            compareParam: val.toString(),
            compareType: 6
          });
        // 对比的时候，让paramName等于正常下拉框此时的label
        if (item.isOld === this.queryData.isOld)
          this.queryData.paramName = item.label;
      });
      this.updateQuery();
    },
    // 对比储值卡
    changeCard_other(val) {
      this.cardList.forEach(item => {
        if (item.cardType === val) {
          switch (item.label) {
            case "全部":
              this.queryData.compareParam = "0/0";
              this.queryData.comParamName = item.label;
              break;
            case "10000及以上":
              this.queryData.compareParam = "10000/0";
              this.queryData.comParamName = item.label;
              break;
            default:
              let a = item.label.split("-");
              this.queryData.compareParam = a[0] + "/" + a[1];
              this.queryData.comParamName = item.label;
              break;
          }
        }
        if (item.cardType === this.cardType) {
          this.queryData.paramName = item.label;
        }
      });
      this.queryData.compareType = 8;
      this.updateQuery();
    },
    // 对比理疗师
    changePerContrant(val) {
      this.queryData.comParamName = val.comParamName;
      this.queryData.compareParam = val.empID.toString();
      this.queryData.compareType = 5;
      this.queryData.paramName = this.empName;
      this.updateQuery();
    }
  }
};
</script>

<style lang="less" scoped>
.loadingStyle {
  color: #999999;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
